// ConvertToCanon/artstyles/RococoStyle.js
export const applyRococoStyle = async (canvas, ctx, setMessage, language) => {
  // 로코코: 우아하고 장식적
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 파스텔 톤으로 변환
  for (let i = 0; i < data.length; i += 4) {
    data[i] = Math.min(255, data[i] * 0.8 + 50);
    data[i + 1] = Math.min(255, data[i + 1] * 0.8 + 40);
    data[i + 2] = Math.min(255, data[i + 2] * 0.8 + 60);
  }
  
  ctx.putImageData(imageData, 0, 0);
};